import instObj from '@/backend/axios-instances'

const resource = "/masterproductions/steps"
const instance = instObj.baseInstance

export default {
  get(parameters) {
    return instance.get(resource, { params: parameters });
  }
}
